import { defineStore } from "pinia";
import axios from "axios";
import Swal from "sweetalert2";
import { piniaPlugin } from "../../index";
import { eventBus } from "../../../assets/eventBus";
import { Inertia } from "@inertiajs/inertia";

export const useTrashStore = defineStore("trash", {
    state: () => ({
        store: piniaPlugin(),
        isShowMoreOption: false,
        deleteItems: [],
        restoreItems: [],
    }),
    getters: {},
    actions: {
        showOptionsButton() {
            this.isShowMoreOption = !this.isShowMoreOption;
        },
        deleteFolderFile(userTypeAbbr, item = null, operationType = "normal") {
            let routeURL = route(userTypeAbbr + "-trash-delete-restore");
            let title = "Are you sure you want to delete selected items?";
            let text = "Deletion of this items will be lost forever!";
            this.deleteItems = [];
            if (item != null) {
                const type = item.dataType === "folders" ? "folder" : "file";
                title = `Are you sure you want to delete this ${type}?`;
                text = "Deletion of this item will be lost forever!";
                this.deleteItems.push({
                    id: item.encryptedId,
                    dataType: item.dataType,
                    type: item.type,
                });
            } else if (operationType === "emptyTrash" && item === null) {
                routeURL = route(userTypeAbbr + "-vault-delete-multiple");
                title = "Are you sure you want to empty trash?";
                text = "All items in trash will be lost forever!";
            } else {
                this.deleteItems = this.store.useMultiSelect.selectedItems;
            }
            Swal.fire({
                text: text,
                title: title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete forever!",
            }).then((result) => {
                if (result.value) {
                    this.store.useMultiSelect.showTopProgress = true;
                    axios
                        .post(
                            routeURL,
                            {
                                items: this.deleteItems,
                                operationType: "delete",
                            },
                            {}
                        )
                        .then((response) => {
                            this.store.useMultiSelect.toast = {
                                isSuccess: response.data.success,
                                successMsg: response.data.message,
                                isToastMessage: true,
                            };
                            eventBus.reloadFolderFile("Delete", "folders");
                            this.store.useMultiSelect.showTopProgress = false;
                        })
                        .catch((err) => {
                            if (err.response.status == 422) {
                                if (err.response.data.errors.items) {
                                    this.store.useMultiSelect.toast = {
                                        isSuccess: false,
                                        successMsg:
                                            err.response.data.errors.items[0],
                                        isToastMessage: true,
                                    };
                                } else {
                                    this.store.useMultiSelect.toast = {
                                        isSuccess: false,
                                        successMsg:
                                            err.response.data.errors
                                                .operationType,
                                        isToastMessage: true,
                                    };
                                }
                            } else {
                                this.store.useMultiSelect.toast = {
                                    isSuccess: err.response.data.success,
                                    successMsg: err.response.data.message,
                                    isToastMessage: true,
                                };
                            }
                            this.store.useMultiSelect.showTopProgress = false;
                        });
                }
            });
        },
        restoreFolderFile(userTypeAbbr, item = null, operationType = "normal") {
            let routeURL = route(userTypeAbbr + "-trash-delete-restore");
            let title = "Do you want to restore selected items?";
            let text = "Items will be moved to My Folders!";
            let confirmButtonText = "Restore";
            this.restoreItems = [];
            if (item != null) {
                const type = item.dataType === "folders" ? "folder" : "file";
                title = `Do you want to restore this ${type}?`;
                text = "Item will be moved to My Folders!";
                if (operationType === "takeOutOfTrash") {
                    title = "Take out of trash";
                    text = `To open this ${type} take it out of trash?`;
                    confirmButtonText = "Confirm";
                }
                this.restoreItems.push({
                    id: item.encryptedId,
                    dataType: item.dataType,
                    type: item.type,
                });
            } else {
                this.restoreItems = this.store.useMultiSelect.selectedItems;
            }
            Swal.fire({
                text: text,
                title: title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: confirmButtonText,
            }).then((result) => {
                if (result.value) {
                    this.store.useMultiSelect.showTopProgress = true;
                    axios
                        .post(
                            routeURL,
                            {
                                items: this.restoreItems,
                                operationType: "restore",
                            },
                            {}
                        )
                        .then((response) => {
                            this.store.useMultiSelect.toast = {
                                isSuccess: response.data.success,
                                successMsg: response.data.message,
                                isToastMessage: true,
                            };
                            eventBus.reloadFolderFile("Delete", "folders");
                            this.store.useMultiSelect.showTopProgress = false;
                            if (operationType === "takeOutOfTrash") {
                                setTimeout(() => {
                                    localStorage.getID = JSON.stringify(
                                        item.id
                                    );
                                    item.dataType == "files"
                                        ? window.open(item.viewUrl, "_blank")
                                        : Inertia.visit(item.viewUrl);
                                }, 1500);
                            }
                        })
                        .catch((err) => {
                            if (err.response.status == 422) {
                                if (err.response.data.errors.items) {
                                    this.store.useMultiSelect.toast = {
                                        isSuccess: false,
                                        successMsg:
                                            err.response.data.errors.items[0],
                                        isToastMessage: true,
                                    };
                                } else {
                                    this.store.useMultiSelect.toast = {
                                        isSuccess: false,
                                        successMsg:
                                            err.response.data.errors
                                                .operationType,
                                        isToastMessage: true,
                                    };
                                }
                            } else {
                                this.store.useMultiSelect.toast = {
                                    isSuccess: err.response.data.success,
                                    successMsg: err.response.data.message,
                                    isToastMessage: true,
                                };
                            }
                            this.store.useMultiSelect.showTopProgress = false;
                        });
                }
            });
        },
        emptyTrash(userTypeAbbr) {
            let routeURL = route(userTypeAbbr + "-empty-trash");
            let title = "Are you sure you want to empty trash?";
            let text = "All items in trash will be lost forever!";
            Swal.fire({
                text: text,
                title: title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete forever!",
            }).then((result) => {
                if (result.value) {
                    this.store.useMultiSelect.showTopProgress = true;
                    axios
                        .post(
                            routeURL,
                            {
                                emptyTrash: "foreverDeleteFoldersFiles"
                            },
                            {}
                        )
                        .then((response) => {
                            this.store.useMultiSelect.toast = {
                                isSuccess: response.data.success,
                                successMsg: response.data.message,
                                isToastMessage: true,
                            };
                            eventBus.reloadFolderFile("Delete", "folders");
                            this.store.useMultiSelect.showTopProgress = false;
                        })
                        .catch((err) => {
                            this.store.useMultiSelect.toast = {
                                isSuccess: err.response.data.success,
                                successMsg: err.response.data.message,
                                isToastMessage: true,
                            };
                            this.store.useMultiSelect.showTopProgress = false;
                        });
                }
            });
        },
    },
});
